export default __webpack_public_path__ + "20d5ff9d1fc7f068841575c3f25ade26.svg";